import { isEthereumLikeToken, isEthereumLike } from '@exodus/ethereum-lib';
export class ExchangeTxSimulator {
    #exchangeAssets;
    #exchangeApproveTokens;
    constructor(params) {
        this.#exchangeAssets = params.exchangeAssets;
        this.#exchangeApproveTokens = params.exchangeApproveTokens;
    }
    simulateTx = async ({ walletAccount, swapTx, ...simulationTxData }) => {
        const asset = this.#exchangeAssets.getAsset({ assetName: simulationTxData.baseAssetName });
        if (!isEthereumLikeToken(asset) && !isEthereumLike(asset)) {
            return asset.api.web3.simulateTransactions({
                ...simulationTxData,
                transactionBuffers: swapTx,
            });
        }
        const simulationTxs = await this.buildTokenApprovalSimulationTxs({
            walletAccount,
            ...simulationTxData,
        });
        const transactions = [];
        if (simulationTxs.length > 0) {
            transactions.push(...simulationTxs);
        }
        return asset.api.web3.simulateTransactions({
            ...simulationTxData,
            transactions: [...transactions, swapTx],
        });
    };
    buildTokenApprovalSimulationTxs = async ({ walletAccount, ...simulationTxData }) => {
        if (!simulationTxData.approveToken?.spenderAddress) {
            return [];
        }
        try {
            return await this.#exchangeApproveTokens.buildTokenApprovalSimulationTx({
                assetId: simulationTxData.approveToken.assetId,
                spenderAddress: simulationTxData.approveToken.spenderAddress,
                walletAccount,
                approveAmount: simulationTxData.approveToken.approveAmount,
                chainId: simulationTxData.approveToken.chainId,
            });
        }
        catch {
            return [];
        }
    };
}
const exchangeTxSimulatorFactory = (args) => new ExchangeTxSimulator({ ...args });
const exchangeTxSimulatorModuleDefinition = {
    id: 'exchangeTxSimulator',
    type: 'module',
    factory: exchangeTxSimulatorFactory,
    dependencies: ['exchangeAssets', 'exchangeApproveTokens'],
};
export default exchangeTxSimulatorModuleDefinition;
